import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MixpanelContext } from "../context/MixpanelContext";

export function MixpanelPageViewTracker() {
  const { mixpanel } = useContext(MixpanelContext);
  const location = useLocation();

  useEffect(() => {
    mixpanel.track("Page View", {
      "URL Path": location.pathname,
      "URL Protocol": location.protocol,
      "URL Query": location.search,
    });
  }, [location, mixpanel]);

  return null;
}
